export default __webpack_public_path__ + "static/clusters-boy-441fd1f5ebbe922aa5c97fe429797b7c.webp";